import { jsx, jsxs } from "react/jsx-runtime";
import { useRef, useCallback, useEffect } from "react";
import classNames from "classnames";
import { useTranslation } from "../../../../lib/hooks/useTranslation.js";
import { useVideoController } from "../../../VideoContextProvider/context/videoController.js";
import { useVideoVolume } from "../../../VideoContextProvider/context/state/volume.js";
import { dBFSToGain, gainToDBFS } from "../../../../lib/videoUtils.js";
import { SpeakerMuted } from "./icons/SpeakerMuted.js";
import { SpeakerUnmuted } from "./icons/SpeakerUnmuted.js";
/* empty css           */
import { Slider } from "../Slider/index.js";
const loudnessMinimum = -50;
function Volume({ isAdPlaying = false, adBlock = false }) {
  const { t } = useTranslation();
  const { volume, muted } = useVideoVolume();
  const videoController = useVideoController();
  const prevMuteState = useRef(null);
  const onVolumeChangeListener = useCallback(
    (e) => {
      const dBFS = e.target.valueAsNumber;
      const gain = dBFS === loudnessMinimum ? 0 : dBFSToGain(dBFS);
      if (gain === 0) {
        videoController.setMute(true);
        return;
      }
      if (muted && gain > 0) {
        videoController.setMute(false);
      }
      videoController.setVolume(gain);
    },
    [videoController, muted]
  );
  const volumeDBFS = muted ? loudnessMinimum : Math.max(gainToDBFS(volume), loudnessMinimum);
  const volumePercentageFromDBFS = muted ? 0 : Math.round((1 - Math.abs(volumeDBFS / loudnessMinimum)) * 100);
  const silent = muted || volume === 0;
  const speakerIcon = silent ? /* @__PURE__ */jsx(SpeakerMuted, {}) : /* @__PURE__ */jsx(
    SpeakerUnmuted,
    {
      className: classNames({
        omega_speakerQuiet: volumePercentageFromDBFS < 50
      })
    }
  );
  useEffect(() => {
    if (isAdPlaying && adBlock) {
      if (!muted) {
        prevMuteState.current = false;
        videoController.setMute(true);
      }
    } else {
      if (prevMuteState.current === false && muted) {
        videoController.setMute(false);
      }
      prevMuteState.current = null;
    }
  }, [isAdPlaying, muted, adBlock, videoController]);
  return /* @__PURE__ */jsxs("div", { className: "omega_volume", children: [
    /* @__PURE__ */jsx(
      "button",
      {
        type: "button",
        onClick: () => videoController.setMute(!muted),
        className: "omega_volume-muteBtn",
        "aria-label": silent ? t("Unmute") : t("Mute"),
        children: speakerIcon
      }
    ),
    /* @__PURE__ */jsx("div", { className: "omega_volume-container", children: /* @__PURE__ */jsx(
        Slider,
        {
          "aria-label": "Volume",
          className: "omega_slider-volume",
          max: 0,
          min: loudnessMinimum,
          onChange: onVolumeChangeListener,
          step: 0.5,
          value: volumeDBFS,
          isVolumeSlider: true
        }
      ) })]
  });
}
export {
  Volume };
//# sourceMappingURL=dist/components/VideoContainer/VideoControlRack/Volume/index.js.map